import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';
export const buttonVariants = cva(
    'inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
    {
        variants: {
            variant: {
                // The ring is `foreground`, not `ring`: `ring` is the brand colour, the
                // same as this fill, so it read as a slightly larger button, not as focus.
                default: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:ring-foreground',
                destructive: 'bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90',
                outline: 'border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground',
                secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
                ghost: 'hover:bg-accent hover:text-accent-foreground',
                link: 'text-primary underline-offset-4 hover:underline',
            },
            size: {
                default: 'h-9 px-4 py-2 min-h-[40px]',
                sm: 'h-8 px-3 text-xs',
                /** `sm` that grows to a 44px touch target below `sm`, for a row's small actions on a phone. */
                'sm-touch': 'h-8 px-3 text-xs max-sm:h-11 max-sm:min-w-11',
                lg: 'h-10 px-8',
                icon: 'h-9 w-9',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
